<template>
  <v-container fluid>
    <v-card class="ui-module-card ui-module-fade-in-up evaluacion-desempeno-shell" flat>
      <v-card-title class="ui-module-titlebar text-h5">Evaluación de desempeño</v-card-title>

      <v-card-text>
        <v-row>
          <v-col cols="12">
            <v-row>
              <v-col cols="2">
                <v-btn text @click="$router.go(-1)">
                  <v-icon>mdi-arrow-left</v-icon>
                  Volver
                </v-btn>
              </v-col>
              <v-col cols="8">
                <personal-info-card-component :personal="personalFotoCuip"></personal-info-card-component>
              </v-col>
            </v-row>
          </v-col>
          <v-col cols="12">
            <v-stepper vertical non-linear v-model="activeStep">
              <v-stepper-step step="1">Información general</v-stepper-step>
              <v-stepper-content step="1">
                <v-container>
                  <v-row justify="center">
                    <v-col cols="12">
                      <v-card class="rounded-sm" elevation="4">
                        <v-card-title>
                          <div class="text-subtitle-1 font-weight-bold">Información general</div>
                        </v-card-title>
                        <v-card-text>
                          <EvaluacionDesempenioForm
                            :idPersonal="id"
                            :personalEvaluado="personalFotoCuip"
                            @save="(evaluations) => getEvaluaciones(evaluations)"
                          />
                        </v-card-text>
                      </v-card>
                    </v-col>
                  </v-row>
                </v-container>
              </v-stepper-content>
              <v-stepper-step step="2">Llenado de evaluaciones</v-stepper-step>
              <v-stepper-content step="2">
                <v-container>
                  <v-row>
                    <v-col v-if="selectedDisciplinaAdministrativa">
                      <v-card color="secondary">
                        <v-card-title>Disciplina administrativa</v-card-title>
                        <v-card-actions>
                          <evaluacion-disciplina-administrativa-dialog-component
                            :id-personal="id"
                            :disciplina-administrativa="selectedDisciplinaAdministrativa"
                          ></evaluacion-disciplina-administrativa-dialog-component>
                        </v-card-actions>
                      </v-card>
                    </v-col>
                    <v-col v-if="selectedDisciplinaOperativa">
                      <v-card color="secondary">
                        <v-card-title>Disciplina operativa</v-card-title>
                        <v-card-actions>
                          <v-btn color="secondary" class="mx-2" @click="activeDialogDisciplinaOperativa = true">
                            Disciplina Operativa
                          </v-btn>
                          <EvaluacionDisciplinaOperativaDialogComponent
                            :active="activeDialogDisciplinaOperativa"
                            @close="activeDialogDisciplinaOperativa = false"
                            :disciplina-operativa="selectedDisciplinaOperativa"
                          />
                        </v-card-actions>
                      </v-card>
                    </v-col>
                  </v-row>
                </v-container>
              </v-stepper-content>
            </v-stepper>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex'
import EvaluacionDisciplinaAdministrativaDialogComponent from '../../components/desarrollo_policial/EvaluacionDisciplinaAdministrativaDialogComponent.vue'
import EvaluacionDisciplinaOperativaDialogComponent from '../../components/desarrollo_policial/EvaluacionDisciplinaOperativaDialogComponent.vue'
import PersonalInfoCardComponent from '../../components/PersonalInfoCardComponent.vue'
import moment from 'moment'
import EvaluacionDesempenioForm from '../../components/desarrollo_policial/evaluacion-desempeño/forms/EvaluacionDesempenioForm.vue'
import GetEvaluacionDisciplinaAdministrativaByIdUseCase from '@/modules/evaluacion-desempeño/application/usecases/GetEvaluacionDisciplinaAdministrativaById.usecase'
import EvaluacionDisciplinaAdministrativaApiRepository from '@/modules/evaluacion-desempeño/infrastructure/EvaluacionDisciplinaAdministrativaApi.repository'
import GetEvaluacionDisciplinaOperativaUseCase from '@/modules/evaluacion-desempeño/application/usecases/GetEvaluacionDisciplinaOperativa.usecase'
import EvaluacionDisciplinaOperativaApiRepository from '@/modules/evaluacion-desempeño/infrastructure/EvaluacionDisciplinaOperativaApi.repository'
import GetEvaluacionProductividadUseCase from '@/modules/evaluacion-desempeño/application/usecases/GetEvaluacionProductividad.usecase'
import EvaluacionProductividadApiRepository from '@/modules/evaluacion-desempeño/infrastructure/EvaluacionProductividadApi.repository'
import RespetoPrincipiosApiRepository from '@/modules/evaluacion-desempeño/infrastructure/RespetoPrincipiosApi.repository'
import GetEvaluacionRespetoPrincipiosUseCase from '@/modules/evaluacion-desempeño/application/usecases/GetEvaluacionRespetoPrincipios.usecase'

export default {
  props: {
    id: {
      type: Number,
    },
  },

  components: {
    EvaluacionDisciplinaAdministrativaDialogComponent,
    EvaluacionDisciplinaOperativaDialogComponent,
    PersonalInfoCardComponent,
    EvaluacionDesempenioForm,
  },

  async mounted() {
    this.SET_PERSONAL_FOTO_CUIP(this.id)
    await this.fetchEstatusProcedimiento()
    await this.fetchProcedimiento()
    await this.fetchReactivoPrincipio()
    await this.fetchTipoEvaluacion()
    await this.fetchIncidencia()
    await this.fetchFaltasAdministrativasByPersonal(this.id)
    await this.fetchTipoFaltaAdministrativa()
    await this.fetchProcedimientos(this.id)
  },

  data() {
    return {
      activeStep: 1,
      loading: false,
      informacionGeneral: {
        fk_idPersonalEvaluador: null,
        fk_idPeriodicidad: null,
        fechaInicial: null,
        fechaFin: null,
        fechaAplicacion: null,
      },
      selectedDisciplinaAdministrativa: null,
      selectedDisciplinaOperativa: null,
      selectedProductividad: null,
      selectedRespetoPrincipios: null,
      activeDialogDisciplinaOperativa: false,
    }
  },

  computed: {
    ...mapGetters('tipoEvaluacion', { tipoEvaluacion: 'getTipoEvaluacion' }),
    ...mapGetters('personal', {
      personal: 'getPersonal',
      personalFotoCuip: 'getPersonalFotoCuip',
    }),
    ...mapGetters('respetoPrincipios', { respetoPrincipios: 'getRespetoPrincipios' }),
    ...mapGetters('disciplinaAdministrativa', { disciplinaAdministrativa: 'getDisciplinaAdministrativa' }),
    ...mapGetters('disciplinaOperativa', { disciplinaOperativa: 'getDisciplinaOperativa' }),
    ...mapGetters('productividad', { productividad: 'getProductividad' }),
    ...mapGetters('faltasAdministrativas', { faltasAdministrativas: 'getFaltasAdministrativas' }),
    ...mapGetters('procedimientos', { listaProcedimientos: 'getProcedimientos' }),

    filteredProcedimientos() {
      if (this.informacionGeneral.fechaAplicacion) {
        return this.listaProcedimientos.filter((procedimiento) => {
          var x = moment(procedimiento.fecha, this.API_DATE_FORMAT).format(this.VUETIFY_DATE_FORMAT)
          return moment(x).isBetween(
            moment(this.informacionGeneral.fechaAplicacion, this.VUETIFY_DATE_FORMAT).subtract(3, 'year'),
            moment(this.informacionGeneral.fechaAplicacion, this.VUETIFY_DATE_FORMAT)
          )
        })
      } else return []
    },

    filteredFaltas() {
      if (this.informacionGeneral.fechaAplicacion) {
        return this.faltasAdministrativas.filter((falta) => {
          var x = moment(falta.fechaDesde, this.API_DATE_FORMAT).format(this.VUETIFY_DATE_FORMAT)
          return moment(x).isBetween(
            moment(this.informacionGeneral.fechaAplicacion, this.VUETIFY_DATE_FORMAT).subtract(3, 'year'),
            moment(this.informacionGeneral.fechaAplicacion, this.VUETIFY_DATE_FORMAT)
          )
        })
      } else return []
    },

    fechaAplicacion: function () {
      return this.informacionGeneral.fechaAplicacion
        ? moment(this.informacionGeneral.fechaAplicacion).format(this.API_DATE_FORMAT)
        : ''
    },
  },

  methods: {
    ...mapActions('estatusProcedimiento', ['fetchEstatusProcedimiento']),
    ...mapActions('procedimiento', ['fetchProcedimiento']),
    ...mapActions('reactivoPrincipio', ['fetchReactivoPrincipio']),
    ...mapActions('tipoEvaluacion', ['fetchTipoEvaluacion']),
    ...mapMutations('personal', ['SET_PERSONAL_FOTO_CUIP']),
    ...mapActions('respetoPrincipios', ['fetchRespetoPrincipios']),
    ...mapActions('disciplinaAdministrativa', ['fetchDisciplinaAdministrativa']),
    ...mapActions('disciplinaOperativa', ['fetchDisciplinaOperativa']),
    ...mapActions('incidencia', ['fetchIncidencia']),
    ...mapActions('faltasAdministrativas', ['fetchFaltasAdministrativasByPersonal']),
    ...mapActions('tipoFaltaAdministrativa', ['fetchTipoFaltaAdministrativa']),
    ...mapActions('procedimientos', ['fetchProcedimientos']),

    async getEvaluaciones({ disciplinaAdministrativaId, disciplinaOperativaId, respetoPrincipiosId, productividadId }) {
      this.loading = true

      this.selectedDisciplinaAdministrativa = await new GetEvaluacionDisciplinaAdministrativaByIdUseCase(
        new EvaluacionDisciplinaAdministrativaApiRepository()
      ).execute({ idPersonal: this.id, idEvaluacion: disciplinaAdministrativaId })

      this.selectedDisciplinaOperativa = await new GetEvaluacionDisciplinaOperativaUseCase(
        new EvaluacionDisciplinaOperativaApiRepository()
      ).execute({ idPersonal: this.id, idEvaluacion: disciplinaOperativaId })

      this.selectedProductividad = await new GetEvaluacionProductividadUseCase(
        new EvaluacionProductividadApiRepository()
      ).execute({ idPersonal: this.id, idEvaluacion: productividadId })

      this.selectedRespetoPrincipios = await new GetEvaluacionRespetoPrincipiosUseCase(
        new RespetoPrincipiosApiRepository()
      ).execute({ idPersonal: this.id, idEvaluacion: respetoPrincipiosId })

      this.activeStep++
      this.loading = false
    },
  },
}
</script>

<style scoped>
.evaluacion-desempeno-shell {
  min-height: calc(100vh - 64px);
  min-height: calc(100dvh - 64px);
}

::v-deep .evaluacion-desempeno-shell.v-card {
  background: transparent !important;
  border: 0 !important;
  box-shadow: none !important;
  backdrop-filter: none !important;
  -webkit-backdrop-filter: none !important;
}

::v-deep .evaluacion-desempeno-shell.v-card:hover {
  transform: none !important;
  box-shadow: none !important;
}
</style>
